import React from 'react';

import { ButtonProps } from '@components/Button';
import { PrimaryButton, ProButton } from '@components/Button/variants';

type EmailInputButtonProps = Extract<ButtonProps, { as: 'button' }> & {
  isPro?: boolean;
  isLoading?: boolean;
};

const EmailInputButton = ({ isPro, ...rest }: EmailInputButtonProps) => {
  const Button = isPro ? ProButton : PrimaryButton;
  return <Button size="small" type="submit" {...rest} />;
};

export default EmailInputButton;
